import { FC } from 'react';

import DropDownClick, { DownPlacement } from 'bloko/blocks/drop/Down/Click';
import Link from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

import ArchiveReason from 'components/BlockedReason';

interface ArchiveReasonWrapperProps {
    title: string;
    text: string;
    action?: string;
    anchor?: string;
}

const ArchiveReasonWrapper: FC<ArchiveReasonWrapperProps> = ({ title, text, action, anchor }) => {
    const trl = useTrls();

    return (
        <>
            <div>{trl(title)}</div>(
            <DropDownClick
                showCloseButton
                render={() => (
                    <ArchiveReason action={action} title={trl(title)} anchor={trl(anchor)} text={trl(text)} />
                )}
                placement={DownPlacement.BottomEnd}
            >
                <Link data-qa="campaign-archive-reason-button">{trl('campaign.actions.status.findReason.link')}</Link>
            </DropDownClick>
            )
        </>
    );
};

export default ArchiveReasonWrapper;
